import { useMainAppSettingItemValue } from '@repo/ccc-main-app-lib/src/lib/mainAppSettings.ts'
import { useApplyPageTheme } from '@repo/internal-tools-app-lib/src/lib/useApplyPageTheme.ts'
import { RouterProvider } from '@tanstack/react-router'
import { router } from './router.tsx'

/**
 * This App component is outside the router.
 * Route changes don't re-render this component.
 */
export const App = () => {
  const theme = useMainAppSettingItemValue('appearance.colorTheme', {
    shouldTrackStateInAnalytics: true,
  })
  useApplyPageTheme(theme)

  return <RouterProvider router={router} />
}
